{
  "language": {
    "name": "Indonesian",
    "title": "Bahasa"
  },
  "format": {
    "currency": "{{value, currency(currency: USD)}}",
    "number": "{{value, number(maximumFractionDigits: 9)}}"
  },
  "button": {
    "auto": "Otomatis",
    "bridge": "Bridge",
    "buy": "Beli",
    "buyNow": "Beli sekarang",
    "cancel": "Batal",
    "connectWallet": "Hubungkan dompet",
    "contactSupport": "Kontak bantuan",
    "continue": "Lanjutkan",
    "copyAddress": "Salin alamat",
    "dark": "Gelap",
    "delete": "Hapus",
    "disconnect": "Tidak terkoneksi",
    "done": "Selesai",
    "exchange": "Pertukaran",
    "getGas": "Dapatkan gas",
    "hide": "Sembunyikan",
    "learnMore": "Pelajari lebih lanjut",
    "lifiCheckout": "Pembayaran LI.FI",
    "lifiExchange": "Pertukaran LI.FI",
    "light": "Terang",
    "max": "maks",
    "ok": "Ya",
    "removeTransaction": "Hapus transaksi",
    "reset": "Atur ulang",
    "resetSettings": "Setel ulang pengaturan",
    "reviewBridge": "Peninjauan bridge",
    "reviewPurchase": "Tinjau pembelian",
    "reviewSwap": "Tinjau swap",
    "seeDetails": "Lihat rinciannya",
    "showAll": "Tampilkan semua",
    "startBridging": "Mulai bridge",
    "startSwapping": "Mulai swap",
    "swap": "Swap",
    "tryAgain": "Coba lagi",
    "viewCoverage": "Melihat cakupan",
    "viewOnExplorer": "Lihat di explorer"
  },
  "header": {
    "activeTransactions": "Transaksi aktif",
    "bridge": "Bridge",
    "checkout": "Checkout",
    "exchange": "Pertukaran",
    "from": "Swap dari",
    "gas": "Gas",
    "payWith": "Bayar dengan",
    "purchase": "Pembelian",
    "purchaseDetails": "Detail pembelian",
    "selectChain": "Pilih jaringan",
    "selectWallet": "Pilih dompet",
    "settings": "Pengaturan",
    "swap": "Swap",
    "to": "Swap ke",
    "transactionDetails": "Rincian transaksi",
    "transactionHistory": "Riwayat transaksi",
    "walletConnected": "Dompet terhubung",
    "youGet": "Anda mendapatkan"
  },
  "info": {
    "message": {
      "autoRefuel": "Gas anda hampir habis {{chainName}}. Dengan melanjutkan, anda akan mendapatkan cukup gas untuk menyelesaikan penukaran.",
      "emptyActiveTransactions": "Transaksi yang sedang berlangsung akan muncul di sini. Setelah selesai, temukan di riwayat transaksi.",
      "emptyTokenList": "Kami tidak dapat menemukan token di jaringan {{chainName}} atau Anda tidak memilikinya. Silakan cari berdasarkan alamat kontrak jika token Anda tidak muncul atau pilih jaringan lain.",
      "emptyTransactionHistory": "Riwayat transaksi hanya disimpan secara lokal dan akan dihapus jika Anda menghapus data browser.",
      "routeNotFound": "Alasannya mungkin: likuiditas rendah, jumlah yang dipilih terlalu rendah, biaya gas terlalu tinggi, atau tidak ada rute untuk kombinasi yang dipilih."
    },
    "title": {
      "autoRefuel": "Dapatkan gas",
      "emptyActiveTransactions": "Tidak ada transaksi yang aktif",
      "emptyTransactionHistory": "Tidak ada transaksi terbaru",
      "routeNotFound": "Rute tidak tersedia"
    }
  },
  "success": {
    "message": {
      "exchangePartiallySuccessful": "Kami telah mencoba menyelesaikan transaksi, tetapi {{tool}} kehabisan likuiditas untuk token {{tokenSymbol}}.",
      "exchangeSuccessful": "Sekarang ada {{amount, number(maximumFractionDigits: 9)}} {{tokenSymbol}} di dompet {{walletAddress}} pada jaringan {{chainName}}.",
      "purchaseSuccessful": "Anda sekarang memiliki {{assetName}} di dompet {{walletAddress}} di chain {{chainName}}."
    },
    "title": {
      "bridgePartiallySuccessful": "Bridge sebagian berhasil",
      "bridgeSuccessful": "Bridge berhasil",
      "purchaseSuccessful": "Pembelian berhasil",
      "refundIssued": "Pengembalian dana diterbitkan",
      "swapPartiallySuccessful": "Swap sebagian berhasil",
      "swapSuccessful": "Swap berhasil"
    }
  },
  "warning": {
    "message": {
      "deleteActiveTransactions": "Transaksi aktif hanya disimpan secara lokal dan tidak dapat dipulihkan jika Anda menghapusnya.",
      "deleteTransactionHistory": "Riwayat transaksi hanya disimpan secara lokal dan tidak dapat dipulihkan jika Anda menghapusnya.",
      "highValueLoss": "Nilai token yang diterima jauh lebih rendah daripada token yang ditukar dan biaya transaksi.",
      "insufficientFunds": "Anda tidak memiliki cukup dana untuk menyelesaikan penukaran.",
      "insufficientGas": "Anda tidak memiliki cukup gas untuk menyelesaikan penukaran. Anda perlu menambahkan setidaknya:",
      "rateChanged": "Nilai tukar telah berubah. Dengan melanjutkan penukaran, Anda akan menerima tarif baru.",
      "resetSettings": "Ini akan mengatur ulang prioritas rute Anda, slippage, harga gas, jembatan yang diaktifkan, dan pertukaran."
    },
    "title": {
      "deleteActiveTransactions": "Hapus seluruh transaksi aktif?",
      "deleteTransaction": "Hapus transaksi ini?",
      "deleteTransactionHistory": "Hapus riwayat transaksi?",
      "highValueLoss": "Kehilangan nilai tinggi",
      "insufficientGas": "Gas tidak mencukupi",
      "rateChanged": "Rate berubah",
      "resetSettings": "Setel ulang pengaturan?"
    }
  },
  "error": {
    "message": {
      "allowanceRequired": "Jumlah transfer untuk {{tokenSymbol}} melebihi jatah Anda saat ini. Tingkatkan jatah Anda dan coba lagi.",
      "insufficientFunds": "Anda tidak memiliki cukup gas untuk menutup biaya transaksi.",
      "slippageThreshold": "Slippage lebih besar dari ambang batas yang ditentukan. Silakan minta rute baru untuk mendapatkan penawaran baru.",
      "transactionFailed": "Silakan periksa block explorer untuk informasi lebih lanjut.",
      "transactionNotSent": "Transaksi tidak terkirim. {{amount, number(maximumFractionDigits: 9)}} {{tokenSymbol}} di {{chainName}} tetap berada di dompet Anda.",
      "transactionRejected": "Tanda tangan Anda diperlukan untuk menyelesaikan transaksi. {{amount, number(maximumFractionDigits: 9)}} {{tokenSymbol}} di {{chainName}} tetap berada di dompet Anda.",
      "unknown": "Silakan coba lagi atau hubungi bagian dukungan."
    },
    "title": {
      "allowanceRequired": "Saldo tidak mencukupi",
      "balanceIsTooLow": "Saldo Anda terlalu sedikit",
      "chainSwitch": "Penggantian jaringan diperlukan",
      "gasLimitIsTooLow": "Gas limit terlalu rendah",
      "insufficientFunds": "Dana tidak mencukupi",
      "slippageNotMet": "Kondisi slippage tidak terpenuhi",
      "transactionCanceled": "Transaksi dibatalkan",
      "transactionFailed": "Transaksi gagal",
      "transactionRejected": "Tanda tangan diperlukan",
      "transactionUnderpriced": "Transaksi di bawah harga",
      "transactionUnprepared": "Tidak dapat menguraikan transaksi",
      "unknown": "Terjadi kesalahan",
      "walletAddressInvalid": "Alamat dompet tidak valid.",
      "walletAddressRequired": "Alamat dompet diperlukan.",
      "walletEnsAddressInvalid": "Alamat dompet tidak valid atau jaringan tidak mendukung ENS."
    }
  },
  "tooltip": {
    "additionalProviderFee": "Jembatan tambahan, DEX, dan biaya layanan.",
    "estimatedNetworkFee": "Perkiraan biaya jaringan.",
    "estimatedTime": "Perkiraan waktu eksekusi swap dalam hitungan menit.",
    "notFound": {
      "text": "Kami tidak dapat menemukan halaman ini.",
      "title": "404"
    },
    "numberOfSteps": "Sejumlah langkah swap. Setiap langkah dapat berisi 1-2 transaksi yang memerlukan tanda tangan.",
    "progressToNextUpdate": "Data yang ditampilkan akan disegarkan secara otomatis setelah {{value}} detik. Klik di sini untuk memperbarui secara manual.",
    "recommended": "Rute murah yang menyeimbangkan kerumitan dan kemudahan penggunaan.",
    "settingsModified": "Pengaturan (diubah)"
  },
  "main": {
    "crossStepDetails": "Bridge dari {{from}} to {{to}} via {{tool}}",
    "currentAmount": "Jumlah saat ini",
    "estimatedTime": "{{value}}m",
    "featuredTokens": "Token unggulan",
    "from": "Dari",
    "fromAmount": "Anda membayar",
    "gasCost": "Biaya Gas",
    "gasFeeEstimated": "perkiraan biaya gas",
    "gasFeePaid": "biaya gas yang dibayar",
    "inProgress": "dalam proses",
    "nftStepDetails": "Beli NFT melalui {{tool}}",
    "onChain": "di {{chainName}}",
    "otherTokens": "Token lainnya",
    "ownedBy": "Dimiliki oleh",
    "process": {
      "crossChain": {
        "actionRequired": "Mohon konfirmasi transaksi",
        "done": "Bridge dikonfirmasi",
        "pending": "Menunggu transaksi bridge",
        "started": "Mempersiapkan transaksi bridge"
      },
      "nft": {
        "done": "NFT dibeli"
      },
      "receivingChain": {
        "done": "Bridge selesai",
        "partial": "Bridge sebagian selesai",
        "pending": "Menunggu jaringan tujuan",
        "refunded": "Dana transaksi bridge dikembalikan"
      },
      "swap": {
        "actionRequired": "Mohon konfirmasi transaksi",
        "done": "Swap selesai",
        "pending": "Menunggu transaksi swap",
        "started": "Mempersiapkan transaksi swap"
      },
      "switchChain": {
        "actionRequired": "Penggantian jaringan diperlukan",
        "done": "Penggantian jaringan berhasil"
      },
      "tokenAllowance": {
        "done": "Izin token disetujui",
        "pending": "Menunggu untuk izin token",
        "started": "Pengaturan izin token"
      }
    },
    "quotedAmount": "Jumlah yang dikutip",
    "rateChange": "Perubahan rate",
    "receiving": "Menerima",
    "refuelStepDetails": "Dapatkan gas melalui {{tool}}",
    "selectChain": "Pilih jaringan",
    "selectChainAndToken": "Pilih jaringan dan token",
    "selectToken": "Pilih token",
    "sendToAddress": "Kirim ke {{address}}",
    "sendToWallet": "Kirim ke dompet berbeda",
    "sending": "Mengirim",
    "sentToAddress": "Dikirim ke {{address}}",
    "stepBridge": "Bridge",
    "stepBridgeAndBuy": "Bridge dan beli",
    "stepDetails": "{{tool}} melalui LI.FI",
    "stepSwap": "Swap",
    "stepSwapAndBridge": "Swap dan bridge",
    "stepSwapAndBuy": "Swap dan beli",
    "supportId": "ID dukungan",
    "swapStepDetails": "Swap di {{chain}} melalui {{tool}}",
    "tags": {
      "cheapest": "Murah",
      "fastest": "Cepat",
      "insurable": "Dapat diasuransikan",
      "insurance": "Asuransi",
      "insured": "Diasuransikan",
      "recommended": "Direkomendasikan",
      "safest": "Aman"
    },
    "to": "Kepada",
    "tokenOnChain": "{{tokenSymbol}} di {{chainName}}",
    "tokenOnChainAmount": "{{amount, number(maximumFractionDigits: 9)}} {{tokenSymbol}} di {{chainName}}",
    "tokenSearch": "Cari berdasarkan nama atau alamat token",
    "valueLoss": "Kehilangan nilai",
    "walletAddressOrEns": "Alamat dompet atau nama ENS"
  },
  "insurance": {
    "bridgeExploits": "Malfungsi jembatan, peretasan, atau eksploitasi",
    "insure": "Asuransikan <0>{{amount, number(maximumFractionDigits: 9)}} {{tokenSymbol}}</0> dalam perjalanan.",
    "insured": "Anda telah mengasuransikan <0>{{amount, number(maximumFractionDigits: 9)}} {{tokenSymbol}}</0> dalam perjalanan:",
    "slippageError": "Kesalahan dalam slippage untuk token yang diterima"
  },
  "settings": {
    "enabledBridges": "Jembatan diaktifkan",
    "enabledExchanges": "Pertukaran diaktifkan",
    "gasPrice": {
      "fast": "Cepat",
      "normal": "Normal",
      "slow": "Lambat",
      "title": "Harga gas"
    },
    "routePriority": "Prioritas rute",
    "showDestinationWallet": "Tampilkan Alamat Tujuan",
    "slippage": "Slippage"
  },
  "wallet": {
    "extensionNotFound": "Pastikan hanya ekstensi browser {{name}} yang aktif sebelum memilih dompet ini."
  }
}
